import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { eEnvironment } from '@Workspace/_generated/enums';
import { IApiSettings } from '@Workspace/_generated/interfaces';
import { Constants } from '@Workspace/common';
import { IClientSettings } from 'libs/interfaces/IClientSettings';
import { Configuration } from 'msal';

import { MsalAngularConfiguration } from '../auth/msad/msal-angular.configuration';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class SettingsService {
    private apiSettings: IApiSettings;
    private clientUrl: string;

    private apiUrl: string;
    private isInitialized = false;

    constructor(private http: HttpClient, private location: Location) {}

    public get IsInitialized() {
        return this.isInitialized;
    }

    public get Environment(): eEnvironment {
        return this.apiSettings.environment;
    }

    public get ApiId(): string {
        return this.apiSettings.apiId;
    }

    public get ClientId(): string {
        return this.apiSettings.clientId;
    }

    public get TenantId(): string {
        return this.apiSettings.tenantId;
    }

    public get AzureAdConfig(): Configuration {
        return {
            auth: {
                clientId: this.ClientId,
                authority: this.TenantId,
                redirectUri: window.location.origin
            },
            cache: {
                cacheLocation: 'localStorage',
                storeAuthStateInCookie: false
            }
        };
    }

    public get AzureAdAngularConfig(): MsalAngularConfiguration {
        return {
            consentScopes: ['user.read', `api://${this.ApiId}/api-access`],
            popUp: true,
            protectedResourceMap: new Map([
                [this.apiUrl, [`api://${this.ApiId}/api-access`]]
            ])
        };
    }

    public get IsLive(): boolean {
        return this.apiSettings.environment === eEnvironment.Live;
    }

    public get isQA(): boolean {
        return this.apiSettings.environment === eEnvironment.QA;
    }
    public get isStageWest(): boolean {
        return this.apiSettings.environment === eEnvironment.SW;
    }

    public get IsLearfield(): boolean {
        return this.createClientUrl('').indexOf('learfield.') >= 0;
    }

    public initializeAsync() {
        return new Promise<void>((resolve, reject) => {
            this.initializeUrls();

            this.http
                .get(this.createClientUrl(Constants.CLIENT_SETTINGS_URL))
                .subscribe(
                    response => {
                        let data: IClientSettings = response as IClientSettings;
                        this.apiUrl = data.apiUrl;

                        this.http
                            .get(this.createApiUrl(Constants.API_SETTINGS_URL))
                            .subscribe(
                                response => {
                                    this.apiSettings = response as IApiSettings;
                                    resolve();
                                },
                                error => {
                                    console.log(error);
                                    reject();
                                }
                            );
                    },
                    error => {
                        console.log(error);
                        reject();
                    }
                );
        });
    }

    public createApiUrl(path: string): string {
        return this.createUrl(this.apiUrl, path);
    }

    public createServerUrl(path: string): string {
        return this.createUrl(this.apiUrl, path).replace('/api/', '/');
    }

    public createClientUrl(path: string): string {
        return this.createUrl(this.clientUrl, path);
    }

    private createUrl(root: string, path: string): string {
        let localRoot = this.getUrl(root);
        
        if (!!path && path.indexOf('/') === 0) {
            path = path.substr(1);
        }
        return localRoot + path;
    }

    private getUrl(url: string): string {
        if (!!url && url.lastIndexOf('/') !== url.length - 1) {
            url = url + '/';
        }

        if (!url) {
            url = '';
        }

        return url;
    }

    private initializeUrls() {
        const angularRoute = this.location.path();
        const url = window.location.origin;

        this.clientUrl = url.replace(angularRoute, '').replace(/#\/?/, '');
    }
}
